import { DataBroker } from './DataBroker';


export async function GetEH() {
	const textData = await DataBroker.getDataText('sp/eh');

	return new Promise((myResolve, myReject) => {
		if (textData === null)
			myReject(DataBroker.getError());
		else
			myResolve(<div className='general' dangerouslySetInnerHTML={{ __html: textData }} />);
	});
};